import { motion } from "framer-motion";

export function ScoreBars({ dimensions, delay = 0 }) {
  return (
    <div className="space-y-3">
      {dimensions.map((d, i) => (
        <div key={d.key} data-testid={`score-${d.key}`}>
          <div className="mb-1 flex items-center justify-between text-sm">
            <span className="font-semibold text-foreground">{d.label}</span>
            <span className="font-mono font-bold text-indigo-600">{d.value}</span>
          </div>
          <div className="h-2.5 overflow-hidden rounded-full bg-secondary">
            <motion.div
              className="h-full rounded-full bg-gradient-to-r from-indigo-500 to-violet-500"
              initial={{ width: 0 }}
              animate={{ width: `${d.value}%` }}
              transition={{ duration: 1, delay: delay + i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
